import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar, Panel, OverlayTrigger, Tooltip} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import Icon from '../../core/components/Icon'
import {UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED, sendUpdateOpeningTicketInstructionAction, updateUpdateOpeningTicketInstructionAction, loadOpeningTicketInstructionStream} from '../actions'
import {UpdateOpeningTicketInstructionAction} from '../models'
import i18n from '../i18n'
import style from './UpdateOpeningTicketInstructionPanel.less'

function openingTicketPurposeAggregator(reference) {
    return (result, openingTicketPurpose) => {
        const resultOpeningTicketPurpose = reference.openingTicketPurposes.find((otp) => otp.uid == openingTicketPurpose.uid)

        if (resultOpeningTicketPurpose) {
            result.push(resultOpeningTicketPurpose)
        } else {
            console && console.warn('openingTicketPurpose "' + openingTicketPurpose.uid + '" doesn\'t exist in referentiel')
        }
        return result
    }
}

function openingTicketInstructionActionUpdate(openingTicketInstruction) {
    return {
        instructionUid: openingTicketInstruction.uid || null,
        title: openingTicketInstruction.title || null,
        text: openingTicketInstruction.text || null
    }
}

class UpdateOpeningTicketInstructionPanel extends Component {
    static propTypes = {
        openingTicketInstruction: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            openingTicketPurposes: []
        }
    }

    componentWillMount() {
        const {dispatch, expanded, openingTicketInstruction, reference} = this.props

        if (expanded) {
            const update = openingTicketInstructionActionUpdate(openingTicketInstruction)
            dispatch(updateUpdateOpeningTicketInstructionAction(update))

            const openingTicketPurposes = openingTicketInstruction.openingTicketPurposes.reduce(openingTicketPurposeAggregator(reference), [])
            this.setState({openingTicketPurposes})
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.expanded != this.props.expanded
            || nextProps.openingTicketInstruction != this.props.openingTicketInstruction
            || nextProps.reference != this.props.reference) {
            const {dispatch, expanded, openingTicketInstruction, reference} = nextProps

            if (expanded) {
                const update = openingTicketInstructionActionUpdate(openingTicketInstruction)
                dispatch(updateUpdateOpeningTicketInstructionAction(update))

                const openingTicketPurposes = openingTicketInstruction.openingTicketPurposes.reduce(openingTicketPurposeAggregator(reference), [])
                this.setState({openingTicketPurposes})
            }
        }
    }

    _sendAction(event) {
        const {dispatch, onSelect} = this.props

        return dispatch(sendUpdateOpeningTicketInstructionAction()).then(() => {
            return dispatch(loadOpeningTicketInstructionStream())
        })
    }

    render() {
        const {dispatch, form, action, reference, openingTicketInstruction, onSubmit, ...others} = this.props
        const {openingTicketPurposes} = this.state

        const header = (
            <h5>{openingTicketInstruction.title}</h5>
        )

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const tooltip = (text) => (
            <Tooltip
                className='tooltip-primary'>
                {text}
            </Tooltip>
        )

        const openingTicketPurposeElement = (openingTicketPurpose) => (
            <li
                key={openingTicketPurpose.uid}>
                {openingTicketPurpose.label}
            </li>
        )

        return (
            <Panel
                header={header}
                {...others}>
                <form className='form-horizontal'>
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='title'
                        label={requiredLabel(i18n.title)}
                        {...form.title()} />
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='textarea'
                        name='text'
                        label={requiredLabel(i18n.text)}
                        {...form.text()} />
                </form>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={(e) => form.validate() && this._sendAction(e) || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                    </ButtonToolbar>
                <div className={style.openingTicketPurposes}>
                    <div className={style.action}>
                        <OverlayTrigger
                            placement='bottom'
                            overlay={tooltip(i18n.openingTicketPurposes)}>
                            <Button
                                href=''
                                bsStyle='link'
                                onClick={(e) => onSubmit(e, 'AssociateDissociateOpeningTicketPurposeFromInstruction', openingTicketInstruction)}>
                                <Icon icon='pencil' size='xs' />
                            </Button>
                        </OverlayTrigger>
                    </div>
                    <Row>
                        <Col sm={6}>
                            <ul>
                                {openingTicketPurposes.slice(0, openingTicketPurposes.length / 2 + 1).map(openingTicketPurposeElement)}
                            </ul>
                        </Col>
                        <Col sm={6}>
                            <ul>
                                {openingTicketPurposes.slice(openingTicketPurposes.length / 2 + 1, openingTicketPurposes.length).map(openingTicketPurposeElement)}
                            </ul>
                        </Col>
                    </Row>
                </div>
            </Panel>
        )
    }
}

UpdateOpeningTicketInstructionPanel = connectForm({
    target: 'action',
    schema: UpdateOpeningTicketInstructionAction.schema,
    action: UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED
})(UpdateOpeningTicketInstructionPanel)

UpdateOpeningTicketInstructionPanel = connect((state) => ({
    reference: state.reference.openingTicketPurposeRef,
    action: state.message.updateOpeningTicketInstructionAction
}))(UpdateOpeningTicketInstructionPanel)

export default UpdateOpeningTicketInstructionPanel


// WEBPACK FOOTER //
// ./lib/message/components/UpdateOpeningTicketInstructionPanel.js